
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { Procedure, ApiGateway, Speciality } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class SpecialityEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    speciality: Speciality;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getSpeciality()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getSpeciality(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('speciality/wAll/' + this.routeParams.id).subscribe((res: Speciality) => {
                    this.speciality = res;
                    this.onDataChanged.next(this.speciality);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(speciality): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('speciality/', speciality).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(speciality): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('speciality/', speciality).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(speciality): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('speciality/' + speciality.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }
}
